var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "lab_profile"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2151_15681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2151_15681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lab_profile_2",
    d: "M6.66646 10.0008V8.33415H13.3331V10.0008H6.66646ZM6.66646 6.66748V5.00081H13.3331V6.66748H6.66646ZM4.9998 11.6675H11.2498C11.6526 11.6675 12.0276 11.7543 12.3748 11.9279C12.722 12.1015 13.0137 12.348 13.2498 12.6675L14.9998 14.9591V3.33415H4.9998V11.6675ZM4.9998 16.6675H14.2081L11.9373 13.6883C11.854 13.5772 11.7533 13.4904 11.6352 13.4279C11.5172 13.3654 11.3887 13.3341 11.2498 13.3341H4.9998V16.6675ZM14.9998 18.3341H4.9998C4.54146 18.3341 4.1491 18.171 3.82271 17.8446C3.49632 17.5182 3.33313 17.1258 3.33313 16.6675V3.33415C3.33313 2.87581 3.49632 2.48345 3.82271 2.15706C4.1491 1.83067 4.54146 1.66748 4.9998 1.66748H14.9998C15.4581 1.66748 15.8505 1.83067 16.1769 2.15706C16.5033 2.48345 16.6665 2.87581 16.6665 3.33415V16.6675C16.6665 17.1258 16.5033 17.5182 16.1769 17.8446C15.8505 18.171 15.4581 18.3341 14.9998 18.3341Z",
    fill: "#4B628A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportList);
export default __webpack_public_path__ + "static/media/report-list.f62d91e4a30643821e87c8659016b3c5.svg";
export { ForwardRef as ReactComponent };